<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        <!-- {{$t('login.login')}} -->
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/'+lang+'.png')">
      </div>
    </div>
		
    <div class="cont">
      <div class="bg-wrapper">
       <!-- <video
          id="bgVideo"
          autoplay="autoplay"
          muted="muted"
          loop="loop"
          playsinline=""
          :src="'https://imgs.imdb99.com/data/mp4/'+randv+'.mp4'"
        /> -->
        <div class="logos">
          <img
            :src="app?.logo"
            style="width: 50%;"
          >
        </div>
        <div class="inputs">
          <div class="phone">
            <input
              v-model.trim="data.username"
              type="text"
              :placeholder="$t('register.inunanme')"
            >
          </div>
          <div class="password">
            <input
              v-model.trim="data.password"
						   
              :type="password"
              :placeholder="$t('login.password')"
            >
          </div>
          <div
            class="loginBtn"
            @click="submit"
          >
            {{ $t('login.login') }}
          </div>
          <div class="tips">
            <i><router-link
              class="link flow"
              to="/register"
            >{{ $t('login.signUp') }}</router-link></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 	<div class="login_logo">
			<img class="logo" src="../images/shop2/logo.png" />
		</div> -->
    <!-- 	<div class="login_logo">
			Happy Marrish
		</div> -->
    <!-- <div class="form"> -->
      <!--     <div class="cut_login">
                <router-link class="cur" to="/login"
                    >{{$t('login.signIn')}}
                    <div class="line"></div>
                </router-link>
                <router-link to="/register"
                    >{{$t('login.signUp')}}
                    <div class="line"></div>
                </router-link>
            </div> -->
      <!--   <div class="item ">
                <span class="icon">
                    <van-icon name="envelop-o" size="25"/>
                </span>
                <input
                    type="text"
                    class="inp"
                    v-model.trim="data.username"
                    :placeholder="$t('login.phoneNumber')"
                />
            </div> -->
      <!-- <div class="item mt">
				<span class="icon">
					<van-icon name="user-o" size="25"/>
				</span><input
			        type="text"
			        class="inp"
			        v-model.trim="data.username"
			        :placeholder="$t('login.phoneNumber')"
			    />
			</div> -->
      <!--  <div class="item">
                <span class="icon">
					<van-icon name="lock" size="25"/>
				</span>
                <input
                    :type="password"
                    class="inp"
                    v-model.trim="data.password"
                    :placeholder="$t('login.password')"
                />
                <div
                    class="eye_bi"
                    @click="showPwd"
                    :class="password == 'text' ? 'eye' : ''"
                ></div>
            </div> -->
      <!-- <div class="item_reset_pwd">
				<van-checkbox v-model="checked" icon-size="14px">{{$t('login.remember')}}</van-checkbox>
                <router-link class="reset_pwd" to="/forgetpwd">{{$t('login.forget')}}</router-link>
            </div> -->
      <!-- <div
			    type="submit"
			    class="basic_btn sbtn"
			    :class="
			        data.username == '' || data.password == '' ? 'no_touch' : ''
			    "
			    @click="submit"
			>
			    {{$t('login.login')}}
			</div> -->
			
      <!-- <div class="register">
				 {{$t('login.signUp')}}<router-link class="link flow" to="/register" >{{$t('register.register')}}</router-link>
			</div> -->
    <!-- </div> -->
    
    <!--  <div
            v-if="msg_show"
            class="kefu"
            :class="show_kefu ? '' : 'kefu_hide'"
            @click="kefu_to"
        >
            <img class="kefu_img" src="../images/shop2/kefu.jpg" />
        </div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import {CountDown, Icon,Checkbox} from 'vant'
Vue.use(Checkbox).use(Icon);

export default {
    name: "Login",
    data() {
        return {
			lang:this.$i18n.locale||"zh_cn",
            password: "password",
            show_kefu: true,
            msg_show: true,
			checked: true,
			app:null,
			randv:1,
            data: {
                username: "",
                password: "",
            },
        };
    },
    created() {
		this.data.username = localStorage.getItem('login_username');
		this.data.password = '';
        this.$parent.footer("user", false);
    },
    mounted() {
		this.randv=Math.floor(Math.random() * 8) + 1;
        var that = this;
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
		Fetch('/index/webconfig').then((r)=>{
			this.app = r.data;
		});
    },
    methods: {
        kefu_to() {
            if (this.show_kefu) {
				// window.location.href=this.app.kefu_link;
				this.$router.push("/kefu2");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            if (!this.data.username) {
                this.$toast(this.$t('register.inunanme'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }
			
			if(this.checked){
				localStorage.setItem('login_username', this.data.username);
				localStorage.removeItem('login_password');
			}
			
			if(!this.checked){
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');
			}

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password
            })
                .then((res) => {
					if(res.data.token){
					    localStorage.setItem('token', res.data.token);
					}
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                })
                .then(() => {
                    this.$router.replace({
                        path:
                            this.$router.history.current.query.redirect || "index",
                    });
					// this.$router.replace({
					//     path:"agree",
					// });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.login_bg {
    width: 100%;
    height: 48px;
    overflow: hidden;
    background: none;
    background-size: 100% 100%;
	position: relative;
	z-index: 100;
	.language{
		position: absolute;
		top: 4px;
		right: 0;
		height: 36px;
		img{
			height: 100%;
		}
	}
}

.basic_wrap .form {
    margin: 0 auto ;
    width: 94%;
    height: 332px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 0 8%;
	opacity: 0.85;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #808080;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #db49aa;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #f90, #f18a11);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 68px;
    border-bottom: 1px solid #f0f1f3;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;

    .icon {
        width: 32px;
        height: 27px;

        img {
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: green;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}
.van-checkbox{
	margin-top: 20px;
}
.reset_pwd{
	color: #323233;
	margin-top: -20px;
	display: block;
}

.basic_btn {
    margin: 39px auto 0 auto;
	
	height: 45px;
	line-height: 45px;
	font-size: 16px;
	text-align: center;
	color: #fff;
	border: 10px;
	border-radius: 5px;
	background: linear-gradient( 147deg, rgb(113, 183, 255), rgb(23, 131, 252) 74% );
}
.big_tit{
	color: #000;
}
/deep/ .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #db49aa;
    border-color: #db49aa;
}
/deep/ .van-icon {
  
}
.login_logo {
    width: 100%;
    color: #fff;
    text-align: center;
    -webkit-animation: bot_top-data .3s;
    animation: bot_top-data .3s;
	font-size: 16px;
	color: #333;
	font-weight: bold;
	margin-top: 10px;
}
.login_logo img {
    width: 25%;
	-webkit-animation: logobig-data .5s;
	animation: logobig-data .5s;
}
.form{
	-webkit-animation: bot_top-data .3s;
	animation: bot_top-data .3s;
}
@-webkit-keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}

@keyframes bot_top-data {
    0% {
        margin-top: 1000px;
        opacity: 0;
    }
    100% {
        margin-top: 0;
        opacity: 1;
    }
}
@-webkit-keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	@keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	.register{
		line-height: 30px;
		text-align: center;
		margin-top: 30px;
		font-size: 15px;
	}
	.basic_wrap {
		height: 100vh;
		max-width: 750px;
		background: url(../images/ban5/loginbg.png) no-repeat top;
		background-size: 100% ;
		padding-bottom: 10%;
		background-color: #FFF;
		filter: opacity(80%);
		background-position: 50%;
		background-size: cover;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
	}
	.area_code{
		font-size: 16px;
		line-height: 20px;
		padding: 5px;
	}
	/deep/ .van-checkbox__label{
		line-height: 20px;
		font-size: 14px;
		color: #000;
		font-weight: 700;
	}
	input{
		font-size: 14px;
		color: #000;
	}
	input::placeholder {
		font-size: 14px;
		color: #000;
		font-weight: 700;
	}
	.basic_btn{
		font-size: 18px;
	}
	.flow {
		color: red;
		font-weight: bolder;
		font-size: 16px;
	}
	
	.cont {
	position: absolute;
	width: 100%;
	height: 100vh;
	background-size: 100% 100%;
	bottom: 0;
	background: linear-gradient(-45deg,#7e5678,#e6c3a1);
	z-index: 2
	}
	
	.bg-img {
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover
	}
	
	.bg-wrapper {
	position: relative;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(hsla(0,0%,100%,0),#7e5678)
	}
	
	.logos {
		position: absolute;
		width: 90%;
		top: 100px;
		text-align: center;
		align-items: center;
		display: flex;
		justify-content: center;
		margin: 0 5%
	}
	
	.imgList-left,.imgList-right {
	position: absolute;
	z-index: 999;
	top: 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100px;
	justify-content: space-around
	}
	
	.imgList-right {
	right: 17px
	}
	
	.imgList img {
	width: 40px;
	height: 40px
	}
	
	.inputs {
		top: 0;
		position: absolute;
		margin-top: 35vh;
		border-radius: 50px;
		opacity: .85;
		padding: 0 30px;
		box-sizing: border-box;
		width: 100%
	}
	
	.name {
	font-size: 14px;
	color: #fff;
	font-weight: 700
	}
	
	input {
	background: #fff;
	border: none;
	width: 100%;
	border-radius: 6.667vw;
	padding: 7px 0;
	font-size: 16px;
	border: 0;
	height: 7vh;
	text-align: center
	}
	
	.password {
	margin-top: 20px
	}
	
	.loginBtn {
	margin: 3vh auto 0 auto;
	line-height: 7vh;
	text-align: center;
	margin-top: 11.333vw;
	width: 100%;
	height: 7vh;
	border-radius: 6.667vw;
	color: #fff;
	background: linear-gradient(90deg,#6529c9,#cc2996);
	font-size: 2vh;
	font-weight: bolder
	}
	
	.tips {
	width: 100%;
	text-align: center;
	font-size: 14px;
	color: #fff;
	margin-top: 2vh
	}
	
	video {
	position: fixed;
	top: 50%;
	left: 50%;
	min-width: 100%;
	min-height: 100%;
	width: auto;
	height: auto;
	z-index: -100;
	transform: translateX(-50%) translateY(-50%);
	background: size cover;
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover
	}
	
	.cont {
	position: absolute;
	width: 100%;
	height: 100vh;
	background-size: 100% 100%;
	bottom: 0;
	background: linear-gradient(-45deg,#7e5678,#e6c3a1);
	z-index: 2
	}
	
	.bg-img {
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover
	}
	
	.bg-wrapper {
	position: relative;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(hsla(0,0%,100%,0),#7e5678)
	}
	
	.imgList {
	position: absolute;
	right: 17px;
	z-index: 999;
	top: 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100px;
	justify-content: space-around
	}
	
	.imgList img {
	width: 40px;
	height: 40px
	}
	
	.names {
	font-size: 14px;
	color: #fff;
	font-weight: 700
	}
	
	input {
	background: #fff;
	border: none;
	width: 100%;
	border-radius: 6.667vw;
	padding: 7px 0;
	font-size: 16px;
	border: 0;
	height: 7vh;
	text-align: center
	}
	
	.registerBtn {
	margin: 3vh auto 0 auto;
	line-height: 7vh;
	text-align: center;
	margin-top: 11.333vw;
	width: 100%;
	height: 7vh;
	border-radius: 6.667vw;
	color: #fff;
	background: linear-gradient(90deg,#6529c9,#cc2996);
	font-size: 15px;
	font-weight: bolder
	}
	
	/* Keep the existing background image and video; only restyle the foreground. */
	.basic_wrap { background-color: #120907; filter: none; }
	.login_bg { height: 54px; border-bottom: 1px solid rgba(185, 135, 59, .45); background: rgba(27, 16, 13, .96); }
	.login_bg .back_left { filter: sepia(1) saturate(1.2); }
	.login_bg .language { top: 8px; right: 12px; height: 28px; padding: 3px; border: 1px solid rgba(230, 182, 105, .5); border-radius: 50%; background: rgba(18, 9, 7, .72); }
	.cont { background: linear-gradient(180deg, rgba(18, 9, 7, .36), rgba(18, 9, 7, .78)); }
	.bg-wrapper { background: transparent; }
	.logos { top: clamp(64px, 10vh, 88px); }.logos img { filter: drop-shadow(0 6px 16px rgba(0, 0, 0, .65)); }
	.inputs { width: calc(100% - 28px); margin: clamp(318px, 39vh, 350px) 14px 0; padding: 20px 16px 17px; border: 1px solid rgba(230, 182, 105, .58); border-radius: 17px; background: rgba(27, 16, 13, .83); box-shadow: 0 14px 28px rgba(0, 0, 0, .34), inset 0 1px 0 rgba(255, 235, 188, .1); }
	.inputs input { height: 48px; padding: 0 12px; border: 1px solid rgba(230, 182, 105, .45); border-radius: 12px; background: rgba(12, 6, 5, .74); color: #f8ead0; font-size: 14px; text-align: left; box-sizing: border-box; }
	.inputs input::placeholder { color: rgba(255, 239, 207, .55); font-size: 14px; font-weight: 400; }.password { margin-top: 12px; }
	.loginBtn { height: 48px; margin-top: 20px; border: 1px solid rgba(246, 208, 134, .66); border-radius: 12px; background: linear-gradient(110deg, #7c0405, #b3311a); box-shadow: 0 7px 14px rgba(0, 0, 0, .3); color: #fff0cf; font-size: 14px; line-height: 48px; }
	.tips { margin-top: 30px; color: rgba(255, 239, 207, .72); font-size: 12px; }.flow { color: #e6b669; font-size: 14px; }
	/* Forever Link reception lobby background with a clear light-gold login surface. */
	.basic_wrap {
		position: relative;
		overflow: hidden;
		background: #fff5e3 url('../images/forever-link-lobby-login.png') center center / cover no-repeat;
	}
	.login_bg {
		border-bottom-color: rgba(190, 139, 52, .45);
		background: rgba(255, 252, 245, .94);
		box-shadow: 0 2px 12px rgba(125, 82, 35, .08);
	}
	.login_bg .back_left {
		filter: sepia(.55) saturate(1.25);
	}
	.login_bg .language {
		background: rgba(255, 253, 248, .88);
		box-shadow: 0 3px 9px rgba(125, 82, 35, .1);
	}
	.cont {
		background: linear-gradient(180deg, rgba(255, 253, 248, .08) 0%, rgba(255, 248, 235, .2) 45%, rgba(255, 245, 227, .58) 100%);
	}
	.logos {
		top: clamp(72px, 11vh, 98px);
	}
	.logos img {
		filter: drop-shadow(0 6px 16px rgba(92, 58, 26, .28));
	}
	.inputs {
		border-color: rgba(190, 139, 52, .5);
		background: rgba(255, 253, 248, .88);
		box-shadow: 0 15px 30px rgba(125, 82, 35, .16), inset 0 1px 0 rgba(255, 255, 255, .9);
		backdrop-filter: blur(6px);
	}
	.inputs input { border-color: rgba(190, 139, 52, .42); background: rgba(255, 253, 248, .9); color: #533126; }
	.inputs input::placeholder { color: #a57b62; }
	.loginBtn { border-color: rgba(166, 35, 61, .42); background: linear-gradient(105deg, #a6233d, #ca5a5b); color: #fff8e8; box-shadow: 0 7px 14px rgba(126, 28, 47, .18); }
	.tips { color: #815c45; }
	.flow { color: #a6233d; }

	/* Keep the absolute login layer inside the desktop application canvas. */
	.basic_wrap {
		position: relative;
		overflow: hidden;
	}
	.cont {
		left: 0;
		right: 0;
		width: 100%;
		box-sizing: border-box;
		overflow: hidden;
	}
	@media screen and (min-width: 768px) {
		.inputs {
			left: 14px;
			right: 14px;
			width: auto;
			margin-left: 0;
			margin-right: 0;
		}
	}
</style>
